module.exports = __webpack_public_path__ + "ui-static/img/external-vms-no-items_light.e6c847ef.svg";